// extracted by mini-css-extract-plugin
export default {"table-row":"CartItem_table-row__-6Vmm","table-row-name":"CartItem_table-row-name__YSzrU","arrow":"CartItem_arrow__XETEO"};